export default function NoYesRadio({ identifier, mandatory, onChange, value, disabled }) {
    return (
        <div className={"no-yes-radio-container fade-in " + (mandatory ? "mandatory-input" : "")} data-type="noyesradio">
            <input type="radio" value="0" className="toggle-btn no-btn " name={identifier} id={"no-btn-" + identifier}
                checked={value === "0"}
                onChange={(e) => onChange(e)}
                required={mandatory} />
            <label htmlFor={"no-btn-" + identifier}>NO</label>
            <input type="radio" value="1" className="toggle-btn yes-btn" name={identifier} id={"yes-btn-" + identifier}
                checked={value === "1"}
                onChange={(e) => onChange(e)}
            />
            <label htmlFor={"yes-btn-" + identifier}>YES</label>
        </div>
    )
}